"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormattedValue = require("../../FormattedValue");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TextCell = _ref => {
  let {
    mobileHeaderValue,
    columnKey,
    cellData
  } = _ref;
  function renderValue(cellData, index) {
    const {
      value,
      postfix
    } = cellData;
    return postfix ? /*#__PURE__*/_react.default.createElement(_FormattedValue.FormattedValue, {
      key: index,
      value: value,
      postfix: postfix
    }) : /*#__PURE__*/_react.default.createElement("span", {
      key: index
    }, value);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "item-cell ".concat(columnKey, "-grid")
  }, mobileHeaderValue && /*#__PURE__*/_react.default.createElement("div", {
    className: "head-cell-mobile mr-2"
  }, mobileHeaderValue), Array.isArray(cellData) ? /*#__PURE__*/_react.default.createElement("div", {
    className: columnKey
  }, cellData.map((data, index) => renderValue(data, index))) : renderValue(cellData, 0));
};
var _default = exports.default = TextCell;